/**
 * Web shim for react-native-unistyles v3.
 *
 * Unistyles v3 requires a babel plugin to inject an `id` argument into
 * StyleSheet.create calls.  The landingpage uses SWC (forceSwcTransforms)
 * so the babel plugin cannot run.  This shim provides a minimal web-compatible
 * implementation that works without the plugin.
 */

let _config = {}

const StyleSheet = {
  configure(config) {
    _config = config
  },
  create(stylesheetOrFactory) {
    if (typeof stylesheetOrFactory === 'function') {
      const theme = _config.themes?.[_config.settings?.initialTheme] ?? {}
      return stylesheetOrFactory(theme)
    }
    return stylesheetOrFactory
  },
}

module.exports = { StyleSheet }
